import React from "react";
import { embededVideoUrl, embededVideoUrl2 } from "../constants";
const HealthCare = () => {
  return (
    <section className="!px-4 md:!px-10" id="promotions">
      <div className=" flex flex-col md:flex-row space-x-10 max-w-custom mx-auto">
        <div className="py-13.5 md:py-30 w-full md:w-[60%]">
          <div className="text-primaryText font-medium text-6.5 leading-7.5 md:text-14 md:leading-14 pt-3 pb-11 font-halyard tracking-normal">
            Promotions
          </div>
          <div className="border">
            <iframe
              className="h-[450px] w-full"
              src={embededVideoUrl}
              title="promotional video"
            ></iframe>
          </div>
          <div className="border">
            <iframe
              className="h-[450px] w-full"
              src={embededVideoUrl2}
              title="promotional video"
            ></iframe>
          </div>
        </div>
        <div className="w-full md:w-[40%] flex self-end">
          <div className="flex flex-col gap-y-7 text-[16px] md:text-md font-normal leading-6.5 md:leading-7  text-midGray   justify-end xl:justify-center items-center lg:px-10 !ml-0 md:ml-auto !pt-4 pb-10 md:!pt-0 font-dm-sans md:!justify-start tracking-normal md:h-[450px]  ">
            <span>
              Total Urgent Care revolutionizes the healthcare experience in
              Zimbabwe by providing families with access to reliable and
              comprehensive healthcare services that cater to their unique
              needs.
            </span>
            <span>
              Our innovative approach includes online payments for medical
              bills, and medical appointment scheduling, all designed to offer
              convenience and efficiency from the comfort of home.
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HealthCare;
